import {
    UPDATE_NVQUAL_CURRENT_STATUS,
    UPDATE_NVQUAL_CURRENT_COMMENT,
    UPDATE_NVQUAL_CURRENT_EDIT,
    UPDATE_NVQUAL_CURRENT_REVISION_NAME
  } from './constants'

  import { UPDATE_CURRENT_REVISION } from 'containers/Project/NvqualSection/constants'
  import { createReducer } from 'helpers/ReducerUtil'
  import { combineReducers } from 'redux'
  import _ from 'lodash'
  
  
  const revisionStatus = createReducer(0, {
    [UPDATE_NVQUAL_CURRENT_STATUS]: (prev, { statusNum }) => statusNum,
    [UPDATE_NVQUAL_CURRENT_EDIT]: (prev, { curRev }) => _.get(curRev, 'revision.nvqualResultId', null),
    [UPDATE_CURRENT_REVISION]: (prev, { rev }) => _.get(rev, 'revision.nvqualResultId', null),
  })
  
  const comment = createReducer('', {
    [UPDATE_NVQUAL_CURRENT_COMMENT]: (prev, { text }) => text != null ? text : '',
    [UPDATE_NVQUAL_CURRENT_EDIT]: (prev, { curRev }) => _.get(curRev, 'revision.comments', ''),
    [UPDATE_CURRENT_REVISION]: (prev, { rev }) => _.get(rev, 'revision.comments', '')
  })

  const revisionName = createReducer('', {
    [UPDATE_NVQUAL_CURRENT_REVISION_NAME]: (prev, { text }) => text ? text : '',
    [UPDATE_NVQUAL_CURRENT_EDIT]: (prev, { curRev }) => _.get(curRev, 'revision.name', ''),
    [UPDATE_CURRENT_REVISION]: (prev, { rev }) => _.get(rev, 'revision.name', '')
  })
  
  export default combineReducers({
    revisionName: revisionName,
    comment: comment,
    revisionStatus: revisionStatus,
  })
